import VoiceOrb from "@/components/VoiceOrb";
import { Mic, Keyboard, Paperclip } from "lucide-react";

export function VoiceHelpAction({ onClick }) {
  return (
    <button
      type="button"
      data-testid="voice-help-action"
      onClick={onClick}
      className="mx-auto mt-1 min-h-[44px] px-3 text-[12px] font-ui text-brand-ink2 underline decoration-brand-lineStrong underline-offset-4 hover:text-brand-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-rose rounded-full"
    >
      A voz não respondeu
    </button>
  );
}

// Shared audio-first intro overlay (Regra Majoritária: voice is the primary CTA).
// Previously duplicated in OnboardingPersona and AvatarBuilder. The attach action
// is optional — pages that don't accept documents simply omit onAttach.
export default function AudioFirstOverlay({
  title,
  description,
  onVoice,
  onText,
  onAttach,
  voiceLabel = "Iniciar conversa ao vivo",
  textLabel = "Prefiro digitar",
  recovery = false,
}) {
  return (
    <div
      data-testid="audio-first-intro"
      role={recovery ? "alertdialog" : undefined}
      aria-live={recovery ? "assertive" : undefined}
      aria-labelledby="audio-first-title"
      aria-describedby="audio-first-description"
      className="absolute inset-0 z-20 rounded-3xl flex items-center justify-center p-6"
      style={{ background: "rgba(12,9,10,0.88)", backdropFilter: "blur(10px)" }}
    >
      <div className="text-center max-w-sm">
        <div className="flex justify-center mb-6">
          <VoiceOrb state="idle" size={110} showLabel={false} />
        </div>
        <h3 id="audio-first-title" className="font-display text-2xl lg:text-3xl text-brand-ink mb-2">
          {title}
        </h3>
        <p id="audio-first-description" className="text-[14px] text-brand-ink2 mb-7">{description}</p>
        <button
          type="button"
          data-testid="intro-voice-btn"
          onClick={onVoice}
          autoFocus={recovery}
          className="w-full inline-flex items-center justify-center gap-2 bg-brand-rose hover:bg-brand-roseHover text-white px-6 py-3.5 rounded-full font-ui text-[14px] tracking-wide transition-colors mb-3 min-h-[44px]"
        >
          <Mic className="w-4 h-4" />
          {voiceLabel}
        </button>
        <div className="flex gap-3">
          <button
            type="button"
            data-testid="intro-text-btn"
            onClick={onText}
            className="flex-1 inline-flex items-center justify-center gap-2 bg-brand-elevated border border-brand-line hover:border-brand-rose text-brand-ink px-4 py-3 rounded-full font-ui text-[13px] transition-colors min-h-[44px]"
          >
            <Keyboard className="w-4 h-4" />
            {textLabel}
          </button>
          {onAttach && (
            <button
              type="button"
              data-testid="intro-attach-btn"
              onClick={onAttach}
              className="flex-1 inline-flex items-center justify-center gap-2 bg-brand-elevated border border-brand-line hover:border-brand-rose text-brand-ink px-4 py-3 rounded-full font-ui text-[13px] transition-colors min-h-[44px]"
            >
              <Paperclip className="w-4 h-4" />
              Anexar doc
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
